var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-6"},[_c('h1',[_vm._v("Artículos en Venta")]),_c('v-row',_vm._l((_vm.articles),function(article){return _c('v-col',{key:article._id,attrs:{"cols":"12","xs":"12","sm":"6","md":"6","lg":"4","xl":"4"}},[_c('articleItem',{attrs:{"article":article}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }